var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "domain-not-found overlay h-100 w-100",
      staticStyle: { "background-color": "#ffffffed" },
    },
    [
      _c(
        "b-row",
        {
          staticClass: "w-100 h-100 align-items-center justify-content-center",
        },
        [
          _c(
            "b-col",
            {
              staticClass: "mt-5 pt-5 text-center",
              attrs: { cols: "8", md: "6" },
            },
            [
              _c("h5", { staticClass: "bold" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm.$t("application.applicationNotFoundReferToBroker")
                    ) +
                    "\n      "
                ),
              ]),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }